/* script */
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { differenceBy } from 'lodash';

// Components
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';

const __vue_script__ = {
    name: 'LegalDropdown',

    components: { DropdownMenu },

    props: {
        legalDocs: {
            type: Array,
            default: () => []
        },

        exclude: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        /** @returns {object[]} */
        availableDocs() {
            this.legalDocs.forEach(ld => ld.id = ld._id);
            return differenceBy(this.legalDocs, this.exclude, 'id');
        },
    },

    methods: {
        /**
         * @param {LegalDocument} doc the document selected by the user
         */
        addDoc(doc) {
            this.$emit('add', this.toField(doc));
        },

        /**
         * Transforms the legal document to a compatible field for the dynamic fields component
         *
         * @param {LegalDocument} doc the document to transform
         *
         * @returns {DynamicField} the transformed object
         */
        toField(doc) {
            return {
                id: doc._id,
                name: doc.title,
                label: doc.title,
                removable: true,
                required: true,
                type: 'legal-document',
                kind: 'legal-document'
            };
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dropdown-menu",
    { staticClass: "legal-dropdown", attrs: { "anchor-pos": "nw" } },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-ctx-icon",
          attrs: { slot: "toggler", disabled: !_vm.availableDocs.length },
          on: {
            click: function ($event) {
              $event.preventDefault()
            },
          },
          slot: "toggler",
        },
        [
          _vm._v(_vm._s(_vm.$t("legal_picker.actions.add_legal"))),
          _c("i", { staticClass: "ic-plus" }),
        ]
      ),
      _c(
        "ul",
        _vm._l(_vm.availableDocs, function (doc) {
          return _c("li", { key: doc._id }, [
            _c(
              "a",
              {
                staticClass: "available-field",
                on: {
                  click: function ($event) {
                    return _vm.addDoc(doc)
                  },
                },
              },
              [_vm._v(_vm._s(doc.title))]
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/registrations/LegalDropdown.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__